<template>
  <transition name="fade">
    <div class="col-span-4 col-start-4">

<!--
      <div
        v-if="!logingOut"
        class="[&_h2]:text-t5 mb-6 max-w-xl text-center"
        v-html="webapp_config.msg.welcome_msg"
      ></div>
-->
    </div>
  </transition>

    <div class="col-span-full">
      <div
        class="flex col align-middle justify-center"
        v-if="!logingOut"
      >
          <LoginCiam
            v-if="loginMethod == LOGIN_METHODS.CIAM"
            @loggedIn="onLoggedIn($event)"
            @submit="onSubmit($event)"
          />

            <a :href="apiUrl + '/login/oncall/' + redirectParam" class="text-button mb-3 w-fit m-auto block rounded-[4px] bg-turquoise-60 px-6 py-3 text-white" id="loginBtn">
              Logga in
            </a>
      </div>

    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import auth from '@/auth/index';
import LoginCiam from '@/components/login/login-ciam';
import SVGImage from '@/components/login/svgimage';
import Loader from '@/components/ui/loader';
import { XPAND_BASEURL } from '@/config';
import { LOGIN_METHODS, AUTH_STATUSES } from '@/config/constants';
import { matchingErrorMessage } from '@/helpers';
import { dataLayerPush } from '@/helpers/datalayer';
import { API_BASEURL_V2 } from '@/config';
import { axios as axios_new_api } from '@/store/config';

export default {
  components: {
    Loader,
    SVGImage,
    LoginCiam,
  },
  data() {
    function ensureUrl(redirect) {
      const hasOrigion = redirect.indexOf('http') !== -1;
      if(hasOrigion) {
        return redirect;
      }

      redirect = redirect.charAt(0) === '/' ? redirect : `/${redirect}`;
      return location.origin + redirect;

    }
    return {
      LOGIN_METHODS,
      XPAND_BASEURL,
      logingOut: false,
      interestLogin: false,
      redirectURL: this.$route.query.redirect,
      showLoader : false,
      apiUrl: API_BASEURL_V2,
      redirectParam: this.$route.query.redirect ? "?returnUrl=" + ensureUrl(this.$route.query.redirect) : ''
    }
  },
  errorCaptured(err, component, info) {
    this.showLoader = false;
    if (err.response && err.response.status == 401) {
      const match = matchingErrorMessage(err);
      return false;
    }
  },
  computed: {
    ...mapGetters({
      webapp_config: 'webapp_config',
      authStatus: 'authStatus',
    }),
    showOnlyUsername() {
      return !this.webapp_config.allow_bankid_login;
    },

    loginMethod() {
//      return "ciam";
      /**
       * Har man kommit hit men bankid inte är aktiverat, visa vanliga loginen.
       */
      if (!this.webapp_config.allow_bankid_login) return LOGIN_METHODS.USERNAME_PASSWORD;

      /**
       * Använd loginmethod man angett
       */
      if (this.$route.params && this.$route.params.loginMethod)
        return this.$route.params.loginMethod;

      // ingen inloggningsmetod vald. Välj
      return;
    },
  },

  beforeMount() {
    const nonce = this.$route.query.nonce;
    if (nonce) {
      this.handleNonce(nonce);
      return;
    }
    //Check if the user wants to log out
    this.checkLogOut();
  },

  watch: {
    $route() {
      //Check if the user wants to log out
      this.checkLogOut();
    },
  },

  created() {
    if (
      this.redirectURL &&
      (this.redirectURL.indexOf('VacantResidenceDetailInterestReport') !== -1 ||
        this.redirectURL.indexOf('VacantParkingDetailInterestReport') !== -1 ||
        this.redirectURL.indexOf('VacantPremisesDetailInterestReport') !== -1)
    ) {
      this.interestLogin = true;
    }
  },

  methods: {
    mtm() {
      dataLayerPush({ event: 'losenordshantering-glomt-nytt' });
    },

    handleNonce(nonce) {
      this.showLoader = true;
      axios_new_api
        .get('/login/oncall/GetToken?nonce=' + nonce)
        .then((response) => {
          auth.setAuthTokenOnCall(response.data.access_token);
          return this.$store.dispatch('setAuthStatusOnCall', AUTH_STATUSES.LOGGEDIN).then(() => {
            this.$router.push({ name: 'OncallErrorReport' });
          });
        })
        .catch((error) => {
          console.log(error);
          this.showLoader = false;
        });
    },

    async checkLogOut() {
      const hasLogoutParam = this.$route.query.logout !== undefined;
      const isFakePathMatch = this.$route.path === "/login?logout"; // optional, this might not behave as expected

      if ((hasLogoutParam && !!!this.$route.query.logout) || isFakePathMatch) {
        this.logingOut = true;

        try {
          await this.$store.dispatch('logout');
        } catch (error) {
          console.warn("Logout error (ignoring since we allow 401):", error);
        }
      } else {
        this.logingOut = false;
      }
    },

    onSubmit($event) {
      this.showLoader = true;
    },
    onError() {
      this.showLoader = false;
    },
    /**
     * Denna anropas när man loggat in via någon av formulärskomponenterna
     */
    onLoggedIn() {
      // Vanliga login OK. Loggar in via SSO med.
      return this.$store
        .dispatch('loginSsoMe')
        .then(() => {
          if (this.$route.query.redirect) {
            /**
             * Kommer man från "sök ledigt" och skickats till logga in,
             * ska man skickas tillbaka till sök ledigt, vilken ligger på en annan url än mina sidor
             */
            const redirectTo = decodeURIComponent(this.$route.query.redirect);
            if (redirectTo.match(/^https?/) !== null) {
              location.href = this.$route.query.redirect;
            } else {
              this.$router.push({ path: this.$route.query.redirect }, () => {
                this.showLoader = false;
              });
            }
          } else {
            this.$router.push('/', () => {
              this.showLoader = false;
            });
          }
        })
        .catch(() => {
          this.showLoader = false;
        });
    },
  },
};
</script>
